export default __webpack_public_path__ + "static/media/crt3.acf6adc1.jpg";